/* eslint-disable sort-keys */

// Shared opt-out key for the floating help auto-launch preference.
// 3rd party microsite (loaded in BasicIframeModal) posts to /api/addUserOptOut with this key
// when the user checks a "do not show again" option; we check its `optOut` status via /api/checkUserOptOut.
export const AUTOLAUNCH_FLOATING_HELP_OPT_OUT_KEY = 'agent.autolaunch_floating_help';

// Session-scoped flag intended to be set when the floating help modal auto-launches.
// It is intended to be auto-cleared when the user logs out (and/or when closing the browser tab).
export const AUTOLAUNCH_FLOATING_HELP_SESSION_KEY = 'agent.autolaunch_floating_help_session';

export const DEFAULT_BASIC_IFRAME_MODAL_LAUNCHER_URL_ENTRIES = [
  [
    'DASHBOARD_GETTING_STARTED_ADMIN', {
      _id: 'DASHBOARD_GETTING_STARTED_ADMIN',
      contentItemId: '',
      customParamKeys: [],
      postMessageParamKeys: [],
      postMessageTargetOrigin: '',
      resourceId: '',
      resourceType: '',
      url: ''
    }
  ],
  [
    'DASHBOARD_GETTING_STARTED_STUDENT', {
      _id: 'DASHBOARD_GETTING_STARTED_STUDENT',
      contentItemId: '',
      customParamKeys: [],
      postMessageParamKeys: [],
      postMessageTargetOrigin: '',
      resourceId: '',
      resourceType: '',
      url: ''
    }
  ],
  [
    'DASHBOARD_GETTING_STARTED_TEACHER', {
      _id: 'DASHBOARD_GETTING_STARTED_TEACHER',
      contentItemId: '',
      customParamKeys: [],
      postMessageParamKeys: [],
      postMessageTargetOrigin: '',
      resourceId: '',
      resourceType: '',
      url: ''
    }
  ],
  [
    'FLOATING_HELP_ADMIN', {
      _id: 'FLOATING_HELP_ADMIN',
      contentItemId: '',
      customParamKeys: [],
      postMessageParamKeys: [],
      postMessageTargetOrigin: '',
      resourceId: '',
      resourceType: '',
      url: ''
    }
  ],
  [
    'FLOATING_HELP_STUDENT', {
      _id: 'FLOATING_HELP_STUDENT',
      contentItemId: '',
      customParamKeys: [],
      postMessageParamKeys: [],
      postMessageTargetOrigin: '',
      resourceId: '',
      resourceType: '',
      url: ''
    }
  ],
  [
    'FLOATING_HELP_TEACHER', {
      _id: 'FLOATING_HELP_TEACHER',
      contentItemId: '',
      customParamKeys: [],
      postMessageParamKeys: [],
      postMessageTargetOrigin: '',
      resourceId: '',
      resourceType: '',
      url: ''
    }
  ]
];
